/**
 * 门户文本默认配置数据
 */
export const home = [{}]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {
    iconColor: "#ffffff"
  }
]

/**
 * app按钮默认配置数据
 */
export const appHome = [{}]

// 控制抽屉关闭的按钮
export const control_drawer_icon = [
  {
    width: 16,
    height: 16,
    iconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    hoverIconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    clickIconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    pluginName: ["controlDrawerPlugin"],
    iconWidth: 16,
    // iconColor: "#ffffff",
    iconColor: "rgba(0,0,0,0.5)",
    offset: [10, 10, 0, 0],
    margin: [0, 0, 0, "-100%"],
    isQuickSite: true,
    leftType: "%",
    topType: "%",
    left: 100,
    top: 0
  }
]

export const control_popover_icon = [
  {
    width: 16,
    height: 16,
    iconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    hoverIconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    clickIconSrc: "341a90dc58721111ed0b1a44515d233ecc01",
    pluginName: ["controlPopoverPlugin"],
    iconWidth: 16,
    iconColor: "rgba(0, 0, 0, 0.5)",
    offset: [10, 10, 0, 0],
    margin: [0, 0, 0, "-100%"],
    isQuickSite: true,
    leftType: "%",
    topType: "%",
    left: 100,
    top: 0
  }
]
